import React from 'react';
import { forwardRef } from 'react';
import { BeautifulMentionsMenuItemProps } from 'lexical-beautiful-mentions';
import VerifiedIcon from '../../../../../assets/verified-icon.svg';

export const MentionsMenuItem = forwardRef<HTMLLIElement, BeautifulMentionsMenuItemProps>(
  ({ selected, item, isFollowing, isVerified, imgUrl, itemValue, ...props }, ref) => {
    const isTopic = item.trigger === '#';

    return (
      <li
        className={`px-4 py-2 text-sm flex items-center cursor-pointer transition-colors duration-150 ${
          selected ? 'bg-teal-50 text-teal-800' : 'bg-white hover:bg-gray-50 text-gray-700'
        }`}
        {...props}
        ref={ref}
      >
        <div className={`flex-shrink-0 mr-3 ${isTopic ? 'text-teal-500' : 'text-blue-500'}`}>
          {isTopic ? (
            <div className="w-8 h-8 rounded-full flex items-center justify-center bg-teal-100">
              <span className="text-lg font-semibold">#</span>
            </div>
          ) : (
            <div className="w-8 h-8 rounded-full flex items-center justify-center bg-blue-100 overflow-hidden ">
              {item.data?.imgUrl ? (
                <img
                  src={item.data.imgUrl}
                  alt={item.data.name || item.name}
                  className="w-8 h-8 object-cover"
                />
              ) : (
                <span className="text-lg font-semibold">
                  {(item.data?.name || item.name || '')?.charAt(0)?.toUpperCase()}
                </span>
              )}
            </div>
          )}
        </div>

        <div className="flex flex-col">
          <div className="flex items-center">
            <span className="font-medium max-w-[150px] truncate">
              {item.data?.name || item.name}
            </span>
            {item.data?.isVerified && (
              <img src={VerifiedIcon} alt="Verified" className="ml-1 w-4 h-4" />
            )}
          </div>
          {item.data?.display && item.data.display !== item.data?.name && (
            <p className="text-xs text-gray-500">@{item.data.display}</p>
          )}
          {item.description && (
            <span className="text-xs text-gray-500 truncate max-w-xs">{item.description}</span>
          )}
        </div>
      </li>
    );
  }
);

export default MentionsMenuItem;
